$('.mobile-collection .text-with-icon button').click(function () {
  $('.mobile-collection .collection__facets').slideToggle(300);
  $('.mobile-collection .text-with-icon button').toggleClass('opened');
  if ($('.mobile-collection .text-with-icon button').hasClass('opened')) {
    $('.mobile-collection>.text-with-icon').css('borderBottom', 'none');
  } else {
    setTimeout(() => {
      $('.mobile-collection >.text-with-icon').css('border-bottom', '1px solid rgba(0, 0, 0, 0.1)');
    }, 300);
  }
});

$('.facets__floating-filter>button').click(function() {
  $("#facets-drawer").find('.accordion').removeAttr('open');
})

$(window).on('load', function () {
  var pbadge = $("#product_badge");
  var reveiwsElem = pbadge.parent().find('.overlay-goshop-right b');
  var reviewsCount = pbadge.find('.jdgm-prev-badge').attr('data-number-of-reviews');
  var isProductReviews = pbadge.attr('product_reviews_number_enable');

  if(isProductReviews == 'true') {
    reviewsCount = reviewsCount || '100k+';    
    pbadge.hide();
    reveiwsElem.text(reviewsCount);
  }
  
  window.dispatchEvent(new Event('resize'));
})


function syncRebuyGiftMessaging() {
  document.querySelectorAll('.rebuy-cart__progress-gift-variant-select-prompt').forEach(prompt => {
    if (prompt.textContent.trim() === 'Re-Add') {
      prompt.textContent = 'Select Gift';
    }
  });

  const rebuyStatusElement = document.querySelector('[rebuy-status]');
  const shouldLimitMultipleGifts = !rebuyStatusElement || rebuyStatusElement.getAttribute('rebuy-status') === 'false';
  const hasDiscountMessages = document.querySelectorAll('.rebuy-cart__flyout-item-discount-message').length > 0;

  document.querySelectorAll('.rebuy-cart__progress-gifts').forEach(el => {
    el.style.display = shouldLimitMultipleGifts && hasDiscountMessages ? 'none' : '';
  });
}

let rebuyGiftMessagingSyncQueued = false;

function queueRebuyGiftMessagingSync() {
  if (rebuyGiftMessagingSyncQueued) return;

  rebuyGiftMessagingSyncQueued = true;
  requestAnimationFrame(() => {
    rebuyGiftMessagingSyncQueued = false;
    syncRebuyGiftMessaging();
  });
}

for (const eventName of [
  'rebuy.loaded',
  'rebuy:cart.ready',
  'rebuy:cart.change',
  'rebuy:smartcart.ready',
  'rebuy:smartcart.show'
]) {
  document.addEventListener(eventName, queueRebuyGiftMessagingSync);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncRebuyGiftMessaging, { once: true });
} else {
  syncRebuyGiftMessaging();
}


window.addEventListener('load', function () {

  const starClickable = document.querySelector('product-rerender .star-clickable');
  if (starClickable) {
    starClickable.onclick = () => {
      document.querySelector('.shopify-section--apps').scrollIntoView({ behavior: 'smooth' });
    };
  }
});


// Collection/search badge text and links remain correct after section rerenders.
function syncJudgeMeCardBadges() {
  document.querySelectorAll('.ss-judgeme-card-rating .jdgm-prev-badge__text').forEach(text => {
    const badge = text.closest('.jdgm-prev-badge');
    const count = badge && badge.getAttribute('data-number-of-reviews');
    if (count !== null && count !== undefined) text.dataset.ssReviewCount = count;
  });
}
let judgeMeCardSyncQueued = false;
const judgeMeCardObserver = new MutationObserver(() => {
  if (judgeMeCardSyncQueued) return;
  judgeMeCardSyncQueued = true;
  requestAnimationFrame(() => { judgeMeCardSyncQueued = false; syncJudgeMeCardBadges(); });
});
syncJudgeMeCardBadges();
judgeMeCardObserver.observe(document.body, {childList: true, subtree: true});
document.addEventListener('click', event => {
  const badge = event.target.closest('.ss-judgeme-card-rating');
  if (!badge || !badge.closest('product-card') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = badge.dataset.reviewUrl;
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  window.location.assign(target);
}, true);

// Reapply an incoming review anchor once asynchronous widgets have settled.
let incomingReviewAnchorAligned = false;
let incomingReviewAnchorTimer;
function alignIncomingReviewAnchor() {
  if (incomingReviewAnchorAligned || window.location.hash !== '#judgeme_product_reviews' || document.readyState !== 'complete') return;
  const widget = document.getElementById('judgeme_product_reviews');
  if (!widget || !widget.querySelector('.jm-review-item')) return;
  clearTimeout(incomingReviewAnchorTimer);
  incomingReviewAnchorTimer = setTimeout(() => {
    incomingReviewAnchorAligned = true;
    widget.scrollIntoView({behavior: 'auto', block: 'start'});
  }, 500);
}
const incomingReviewAnchorObserver = new MutationObserver(alignIncomingReviewAnchor);
if (window.location.hash === '#judgeme_product_reviews') {
  incomingReviewAnchorObserver.observe(document.body, {childList: true, subtree: true});
  window.addEventListener('load', alignIncomingReviewAnchor, {once: true});
  alignIncomingReviewAnchor();
}

/* Draft-only review dialog lifecycle and Rebuy gift names: 2026-10-15. */
(function () {
  'use strict';
  if (window.__ssDraftUIRepairs) return;
  window.__ssDraftUIRepairs = { version: 2 };
  var activeMedia = null;
  var mediaTrigger = null;
  var lastMediaTrigger = null;
  var queued = false;
  var focusSelector = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function visible(el) {
    if (!el || !el.isConnected) return false;
    var rect = el.getBoundingClientRect();
    var style = getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }
  function dialogs() {
    return Array.from(document.querySelectorAll('.jdgm-modal.jdgm-widget-revamp')).filter(visible);
  }
  function focusables(root) {
    return Array.from(root.querySelectorAll(focusSelector)).filter(function (el) {
      return visible(el) && el.tabIndex >= 0 && !el.closest('[aria-hidden="true"]');
    });
  }
  function rememberTrigger(event) {
    var el = event.target instanceof Element && event.target.closest('.jm-media-thumbnail-list__thumbnail,.jm-expanded-media-grid__item');
    if (el && !el.closest('.jdgm-modal')) lastMediaTrigger = el;
  }
  document.addEventListener('pointerdown', rememberTrigger, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      rememberTrigger(event);
      var trigger = event.target instanceof Element && event.target.closest('.jm-media-thumbnail-list__thumbnail,.jm-expanded-media-grid__item');
      if (!activeMedia && trigger && trigger.getAttribute('role') === 'button' && trigger.tagName !== 'BUTTON' && trigger.tagName !== 'A') {
        event.preventDefault();
        event.stopImmediatePropagation();
        trigger.click();
        return;
      }
    }
    if (!activeMedia || !visible(activeMedia)) return;
    var open = dialogs();
    if (open[open.length - 1] !== activeMedia) return;
    if (event.key === 'Escape') {
      var close = activeMedia.querySelector('button.jm-indicator__close');
      if (!close) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      close.click();
    } else if (event.key === 'Tab') {
      var items = focusables(activeMedia);
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!items.length) return;
      var index = items.indexOf(document.activeElement);
      var next = index < 0 ? (event.shiftKey ? items.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + items.length) % items.length;
      items[next].focus({ preventScroll: true });
    }
  }, true);
  function sync() {
    queued = false;
    var open = dialogs();
    var media = open.filter(function (root) { return root.querySelector('button.jm-indicator__close'); }).pop() || null;
    if (media !== activeMedia) {
      var previous = activeMedia;
      var restore = mediaTrigger;
      activeMedia = media;
      if (media) {
        mediaTrigger = lastMediaTrigger && lastMediaTrigger.isConnected ? lastMediaTrigger : document.activeElement;
        if (open[open.length - 1] === media) media.querySelector('button.jm-indicator__close').focus({ preventScroll: true });
      } else {
        mediaTrigger = null;
        if (previous && !open.length && restore && restore.isConnected && typeof restore.focus === 'function') restore.focus({ preventScroll: true });
      }
    }
    document.documentElement.classList.toggle('ss-review-media-open', !!media);
    document.querySelectorAll('#rebuy-cart .rebuy-cart__progress-gift').forEach(function (gift) {
      var select = gift.querySelector('select');
      var title = gift.querySelector('.rebuy-cart__progress-gift-title');
      var name = title && title.textContent.replace(/\s+/g, ' ').trim();
      if (!select || !name || select.hasAttribute('aria-labelledby')) return;
      if (select.hasAttribute('aria-label') && !select.hasAttribute('data-ss-gift-name')) return;
      var label = 'Choose ' + name + ' color';
      if (select.getAttribute('aria-label') !== label) select.setAttribute('aria-label', label);
      select.setAttribute('data-ss-gift-name', 'true');
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function start() {
    sync();
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return mutation.type === 'childList' || (mutation.target instanceof Element && mutation.target.matches('.jdgm-modal.jdgm-widget-revamp'));
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
